import { render, staticRenderFns } from "./MedicineList.vue?vue&type=template&id=4260c835"
import script from "./MedicineList.vue?vue&type=script&lang=js"
export * from "./MedicineList.vue?vue&type=script&lang=js"
import style0 from "./MedicineList.vue?vue&type=style&index=0&id=4260c835&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports